import React from "react";

/**
 * Samsung wordmark — actual brand PNG supplied by the client.
 *
 * The PNG is a dark-ink logo. On dark surfaces pass `tone="light"` to invert to white.
 * Height presets:  sm ≈ 14px · md ≈ 20px · lg ≈ 30px.
 * Native aspect ratio ≈ 1920 / 295 ≈ 6.508.
 */
const HEIGHTS = { sm: 14, md: 20, lg: 30 };

export default function SamsungLogo({ size = "sm", tone = "dark", className = "", ...rest }) {
  const height = HEIGHTS[size] || size; // allow numeric override
  const width = Math.round(height * (1920 / 295));
  const style = tone === "light"
    ? { filter: "brightness(0) invert(1)" }
    : {};
  return (
    <img
      src="/samsung-logo.png"
      alt="Samsung"
      width={width}
      height={height}
      style={style}
      className={`select-none ${className}`}
      draggable={false}
      {...rest}
    />
  );
}
